import {
    Dialog, DialogContent, Divider, Grid
} from '@mui/material';
import { useTheme } from '@mui/styles';
import { CancelButtonWhite } from '@tassat/button';
import {
    Failure as FailureIcon,
    Success as SuccessIcon
} from '@tassat/icon';
import React from 'react';

import { handleOnClose } from 'Lib/materialUiHelper';
import { ApplicationMuiTheme } from 'Lib/themes/muiTheme';

import type { ActionStatusModalProps, DeterminateHeaderIconProps } from '.';

const determineHeaderIcon = (props: DeterminateHeaderIconProps, theme: ApplicationMuiTheme) => {
    const {
        classes,
        validationFailure
    } = props;

    if (validationFailure) {
        return (
            <FailureIcon
                className={classes.headerIcon}
                iconColor={theme?.app?.applicationColors.failure || '#FA5252'}
            />
        );
    } else {
        return (
            <SuccessIcon
                className={classes.headerIcon}
                iconColor={theme?.app?.applicationColors.successLight || '#7DEC62'}
            />
        );
    }
};

const ActionStatusModal = (props: ActionStatusModalProps) => {
    const {
        classes,
        open,
        onClose,
        BodyComponent
    } = props;

    const theme = useTheme<ApplicationMuiTheme>();

    return (
        <Dialog
            classes={{ paperWidthXl: classes.paperWidthXl }}
            disableEscapeKeyDown
            maxWidth='xl'
            onClose={() => handleOnClose(onClose)}
            open={open}
            transitionDuration={{
                enter: 0,
                exit: 0
            }}
        >
            <Grid
                className={classes.rootMain}
                container
                direction='column'
                spacing={0}
                wrap='nowrap'
            >
                <Grid
                    container
                    item
                    justifyContent='center'
                    spacing={0}
                    xs={12}
                >
                    <Grid
                        className={classes.topCancelButton}
                        item
                    >
                        <CancelButtonWhite onClick={onClose} />
                    </Grid>
                    <Grid
                        alignItems='center'
                        className={classes.headerContainer}
                        container
                        direction='column'
                        item
                        justifyContent='center'
                        spacing={0}
                        wrap='nowrap'
                        xs={12}
                    >
                        {determineHeaderIcon(props, theme)}
                    </Grid>
                </Grid>
                <Divider variant='middle' />
                <Grid
                    item
                    xs={12}
                >
                    <DialogContent>
                        {BodyComponent}
                    </DialogContent>
                </Grid>
            </Grid>
        </Dialog>
    );
};

export default ActionStatusModal;